/// Menu
import MetisMenu from "metismenujs";
import React, { Component } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link, withRouter } from "react-router-dom";
import $ from 'jquery';
import axios from 'axios';

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() {
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

class SideBar extends Component {

  state = {
    sitename: "",
    account: "",
    isAccessDashboard: false,
    isOneShareHolder: false,
    accountType: "",
    vip_user: "",
    tier: "",
  };

  handleLoad = async () => {
    const headers = {
      "Content-Type": "application/json",
      useraccesstoken: process.env.REACT_APP_USER_ACCESS_TOKEN,
      userauthtoken: "Bearer " + window.sessionStorage.getItem("user_jwt"),
    };

    try {
      let res = await axios.get(process.env.REACT_APP_API_URL + "getUserDetails", { headers: headers });
      res = res.data;
      if (res.code === "200") {
        this.setState({
          sitename: res.data.logosettings[0].logo_title,
          account: res.data.account,
          isAccessDashboard: res.data.is_access_dashboard,
          isOneShareHolder: res.data.is_one_share_holder === "Yes" ? true : false,
          accountType: res.data.account_type,
          vip_user: res.data.vip_user,
          tier: res.data.tier,
        });
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  }

  /// Open menu
  toggleFunc2() {
    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)) {
      $(".nav-control").trigger("click");
    }

  }

  /// Open menu
  componentDidMount() {
    this.handleLoad();
    // sidebar open/close
    let btn = document.querySelector(".nav-control");
    let aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);
  }

  state = {
    loveEmoji: false,
  };

  render() {
    const { sitename, account, isAccessDashboard, isOneShareHolder, accountType, vip_user, tier } = this.state;
    /// Path
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];

    /// Active menu
    let
      shareholders = [
        "customer-list",
      ],
      dashBoard = [
        "dashboard",
        "my-wallet",
        "invoices",
        "cards-center",
        "transactions",
        "transactions-details",
        "task",
      ],
      accounts = [
        "fiat",
        "crypto",
        "fiat-incoming-transfers",
        "fiat-outgoing-transfers",
        "fiat-internal-transfers",
        "iban-account"
      ],
      // cardAccounts = [
      //   "my-cards",
      //   "top-up-card",
      //   "my-cards-transactions",
      //   "transfer-account",
      //   "request-card",
      //   "card-settings",
      // ],
      accountsSub = [
        "my-cards",
        "top-up-card",
        "my-cards-transactions",
        "transfer-account",
        "request-card",
        "card-settings",
        "fiat-incoming-transfers",
        "fiat-outgoing-transfers",
        "fiat-internal-transfers",
        "top-up-transactions",
        "card-usage-transactions"
      ],
      cryptoexchanges = [
        "crypto-exchanges",
      ],
      vipuser = [
        "refer"
      ],
      // businesscard = [
      //   "business-card",
      //   'transactions',
      //   'create-card',
      // ],
      transaction = [
        "fiat-transactions",
        "crypto-transactions",
        "wallets-deposit-transaction",
        "wallets-withdrawal-transaction"
      ],
      usersactivitylogs = [
        "users-activity-logs",
      ],
      management = [
        "news",
        "faq"
      ],
      verifyyouraccount = [
        "verify-your-account",
      ]


    return (
      <div className="deznav">
        <PerfectScrollbar className="deznav-scroll">
          <MM className="metismenu" id="menu">

            <li className={`${dashBoard.includes(path) ? "mm-active" : ""}`} style={{ display: (isAccessDashboard && accountType !== "Bank") ? "contents" : "none" }}>
              <Link className={`${path === "" ? "mm-active" : ""}`} to="/dashboard" onClick={(e) => this.toggleFunc2()}>
                <i className="flaticon-381-home-2"></i>
                <span className="nav-text">Dashboard </span>
              </Link>
            </li>

            <li className={`${shareholders.includes(path) ? "mm-active" : ""}`} style={{ display: (account === "Corporate" && !isOneShareHolder && vip_user !== "Yes") ? "contents" : "none" }}>
              <Link className={`${path === "customer-list" ? "mm-active" : ""}`} to="/customer-list" onClick={(e) => this.toggleFunc2()}>
                <i className="flaticon-381-user-4"></i>
                <span className="nav-text">Share Holders</span>
              </Link>
            </li>

            <li className={`${accounts.includes(path) ? "mm-active" : ""}`} style={{ display: (isAccessDashboard && vip_user !== "Yes") ? "contents" : "none" }}>
              <Link className="has-arrow ai-icon" to="#" onClick={(e) => e.preventDefault()}>
                <i className="flaticon-381-user-7"></i>
                <span className="nav-text">Accounts</span>
              </Link>
              <ul className={`${accounts.includes(path) ? "mm-collapse mm-show" : "mm-collapse"}`}>
                <li>
                  <Link style={{ display: (isAccessDashboard && accountType !== "CryptoExchange") ? "block" : "none" }} className={`${path === "iban-account" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/iban-account" : "/verify-your-account"} onClick={() => this.toggleFunc2()}>IBAN Accounts</Link>
                </li>
                <li>
                  <Link style={{ display: (isAccessDashboard && accountType !== "Bank") ? "block" : "none" }} className={`${path === "fiat" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/fiat" : "/verify-your-account"} onClick={() => this.toggleFunc2()}>Fiat Virtual Wallet Accounts</Link>
                </li>
                <li>
                  <Link style={{ display: (isAccessDashboard && accountType !== "Bank") ? "block" : "none" }} className={`${path === "crypto" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/crypto" : "/verify-your-account"} onClick={() => this.toggleFunc2()}>Crypto Accounts</Link>
                </li>

              </ul>
            </li>

             <li className={`${accountsSub.includes(path) ? "mm-active" : ""}`} style={{ display: (isAccessDashboard && accountType !== "Bank") ? "contents" : "none" }}>
              <Link className="has-arrow ai-icon" to="#" onClick={(e) => e.preventDefault()}>
                <i className="flaticon-381-id-card"></i>
                <span className="nav-text">Card</span>
              </Link>
              <ul className={`${accountsSub.includes(path) ? "mm-collapse mm-show" : "mm-collapse"}`}>
                <li>
                  <Link className={`${path === "my-cards" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/my-cards" : "/verify-your-account"} onClick={() => this.toggleFunc2()}>
                    My Cards
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "top-up-card" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/top-up-card" : "/verify-your-account"} onClick={() => this.toggleFunc2()}>
                    Top up Card
                  </Link>
                </li>
                {/* <li>
                  <Link className={`${path === "my-cards-transactions" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/my-cards-transactions" : "/verify-your-account"}>
                    Transactions
                  </Link>
                </li> */}
                <li className={`${path.includes("transactions") ? "mm-active" : ""}`}>
                  <Link className="has-arrow" to="#" onClick={(e) => e.preventDefault()}>
                    Transactions
                  </Link>
                  <ul className={`${path.includes("transactions") ? "mm-collapse mm-show" : "mm-collapse"}`}>
                    <li>
                      <Link className={`${path === "top-up-transactions" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/top-up-transactions" : "/verify-your-account"} onClick={() => this.toggleFunc2()}>
                        Top Up Transactions
                      </Link>
                    </li>
                    <li>
                      <Link className={`${path === "card-usage-transactions" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/card-usage-transactions" : "/verify-your-account"} onClick={() => this.toggleFunc2()}>
                        Usage Transactions
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            
            <li className={`${cryptoexchanges.includes(path) ? "mm-active" : ""}`} style={{ display: (isAccessDashboard && accountType !== "Bank" && vip_user !== "Yes") ? "contents" : "none" }}>
              <Link className={`${path === "crypto-exchanges" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/crypto-exchanges" : "/verify-your-account"} onClick={() => this.toggleFunc2()}>
                <i className="flaticon-381-networking-1"></i>
                <span className="nav-text">Crypto Exchange</span>
              </Link>
            </li>
            
            <li className={`${transaction.includes(path) ? "mm-active" : ""}`} style={{ display: (isAccessDashboard && accountType !== "Bank" && vip_user !== "Yes") ? "contents" : "none" }}>
              <Link className="has-arrow ai-icon" to="#" onClick={(e) => e.preventDefault()}>
                <i className="flaticon-381-list"></i>
                <span className="nav-text">Transactions</span>
              </Link>
              <ul className={`${transaction.includes(path) ? "mm-collapse mm-show" : "mm-collapse"}`}>
                <li>
                  <Link className={`${path === "fiat-transactions" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/fiat-transactions" : "/verify-your-account"} onClick={() => this.toggleFunc2()}>Fiat</Link >
                </li>
                <li>
                  <Link className={`${path === "crypto-transactions" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/crypto-transactions" : "/verify-your-account"} onClick={() => this.toggleFunc2()}>Crypto</Link>
                </li>
              </ul>
            </li>
            
            <li className={`${vipuser.includes(path) ? "mm-active" : ""}`} style={{ display: (isAccessDashboard && vip_user == "Yes" && tier == 2) ? "contents" : "none" }}>
              <Link className={`${path === "refer" ? "mm-active" : ""}`} to={this.props.kyc === "Approved" ? "/refer" : "/verify-your-account"} onClick={() => this.toggleFunc2()}>
                <i className="flaticon-381-share-2"></i>
                <span className="nav-text">Referral Request</span>
              </Link>
            </li>

            <li className={`${usersactivitylogs.includes(path) ? "mm-active" : ""}`} style={{ display: isAccessDashboard ? "contents" : "none" }}>
              <Link className={`${path === "users-activity-logs" ? "mm-active" : ""}`} to="/users-activity-logs" onClick={() => this.toggleFunc2()}>
                <i className="flaticon-381-note"></i>
                <span className="nav-text">Activity Logs</span>
              </Link>
            </li>
            
            <li className={`${management.includes(path) ? "mm-active" : ""}`} style={{ display: isAccessDashboard ? "contents" : "none" }}>
              <a className={`${path === "news" ? "mm-active" : ""}`} href={process.env.REACT_APP_NEWS_URL || "/news"} target="_blank" rel="noopener noreferrer">
                <i className="flaticon-381-news"></i>
                <span className="nav-text">News</span>
              </a>
            </li>
            
            {/* <li className={`${verifyyouraccount.includes(path) ? "mm-active" : ""}`} style={{ display: isAccessDashboard ? "contents" : "none" }}>
              <Link className={`${path === "verify-your-account" ? "mm-active" : ""}`} to="/verify-your-account" onClick={() => this.toggleFunc2()}>
                <i className="flaticon-381-user"></i>
                <span className="nav-text">Verify Your Account</span>
              </Link>
            </li> */}

          </MM>
          {/* <div className="copyright">
            <p> <strong>{sitename} </strong> © {new Date().getFullYear()} All Rights Reserved </p>
          </div> */}
        </PerfectScrollbar>
      </div>
    );
  }
}

export default withRouter(SideBar);